/** 이미지 리사이즈 컨트롤러 — 좌/우 핸들 드래그로 previewWidth 갱신(직렬화 정합). */
import { startDragResize } from "../../shared/drag-resize.js";

const MIN_W = 100, MAX_W = 1200;

export function attachImageControls(editorEl, ctx) {
  const onChange = (ctx && ctx.onChange) || (() => {});
  const isEditable = () => (ctx && typeof ctx.isEditable === "function" ? ctx.isEditable() : true);
  function onMousedown(e) {
    if (!isEditable()) return; // 읽기전용에선 리사이즈 비활성
    const h = e.target.closest && e.target.closest(".lumir-image-handle");
    if (!h) return;
    e.preventDefault();
    const block = h.closest(".block");
    const inner = h.closest(".lumir-image-inner");
    if (!block || !inner) return;
    if (!block.__props) block.__props = {};
    const measured = inner.getBoundingClientRect ? Math.round(inner.getBoundingClientRect().width) : 0;
    const startW = block.__props.previewWidth || measured || 320;
    startDragResize(e, {
      axis: "x", startVal: startW, min: MIN_W, max: MAX_W, sign: h.classList.contains("left") ? -1 : 1,
      onMove: (w) => { block.__props.previewWidth = w; inner.style.width = w + "px"; },
      onEnd: onChange,
    });
  }
  editorEl.addEventListener("mousedown", onMousedown);
  return { destroy: () => editorEl.removeEventListener("mousedown", onMousedown) };
}
